import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Music, Sparkles, Users } from 'lucide-react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { PageHero, SectionHeading } from '../components/PageBits';
import { Button } from '../components/ui/button';

const Quinceaneras = () => (
  <div className="min-h-screen bg-cream">
    <Nav transparent />
    <PageHero
      eyebrow="Celebra Tu Momento · Celebrate Your Moment"
      title="Quinceañeras at Queensland Ranch"
      subtitle="Una noche mágica bajo las luces — donde tu quinceañera se convierte en una historia inolvidable."
      image="/hero/hero-main.jpg"
    />

    <section className="py-20 bg-cream texture-linen">
      <div className="container mx-auto px-6 max-w-4xl">
        <SectionHeading
          eyebrow="A Milestone Worth Celebrating"
          title="Her Fifteen"
          accent="Unforgettable"
          subtitle="From the padrinos' entrance to the vals, from the ceremonial waltz to the last dance under the string lights — Queensland Ranch was made for celebrations that families remember for a lifetime."
        />

        <div className="grid md:grid-cols-2 gap-6 mt-10">
          {[
            { icon: Sparkles, title: 'Grand Entrance', desc: 'A dramatic arrival on our estate grounds — with room for the entire corte de honor.' },
            { icon: Music, title: 'Dance Floor & DJ Space', desc: 'Checkered dance floor and full sound setup for the vals, the surprise dance, and the party that follows.' },
            { icon: Users, title: 'Room for the Whole Family', desc: 'Up to 130 guests across our seven private acres — with space for every tía, primo, and padrino.' },
            { icon: Calendar, title: 'Full-Day Access', desc: 'Extended, all-day ranch access available — plenty of time for photos, mass prep, and celebration.' },
          ].map((f, i) => (
            <div key={i} className="bg-ivory border border-gold/25 p-7 rounded-lg shadow-sm flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center ring-2 ring-gold/40 ring-offset-4 ring-offset-ivory flex-shrink-0">
                <f.icon className="h-5 w-5 text-gold" />
              </div>
              <div>
                <h3 className="font-serif text-lg text-navy mb-1 font-bold">{f.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 bg-navy text-white rounded-lg p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-[400px] h-[300px] bg-[radial-gradient(ellipse,rgba(184,155,92,0.20)_0%,transparent_60%)] pointer-events-none" />
          <div className="relative z-10 md:flex md:items-center md:justify-between gap-6">
            <div>
              <p className="text-gold text-xs tracking-[0.3em] uppercase mb-2">Custom Quote</p>
              <h3 className="font-serif text-2xl md:text-3xl mb-2">Custom Quinceañera Packages</h3>
              <p className="text-white/80 max-w-xl">Every quinceañera is quoted personally. Mary will tailor the celebration around your daughter's vision — from florals to the vals to the tent.</p>
            </div>
            <Link to="/contact" className="inline-block mt-6 md:mt-0">
              <Button size="lg" className="bg-gold hover:bg-gold/90 text-navy font-semibold px-8 py-6 shadow-xl">
                <Calendar className="mr-2 h-5 w-5" />Request a Quote
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default Quinceaneras;
